import React from 'react'
import { string } from 'prop-types'
import { H4, H5, Separator } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useInnerTileVisuals } from '../hooks/hooks'

export default function TileText({ icon, color, title, header, subHeading }) {
  let iconBgColor = ''
  switch (color) {
    case '#bed21e':
      iconBgColor = '#318d43'
      break
    case '#6db344':
      iconBgColor = '#235c35'
      break
    case '#01b6d1':
      iconBgColor = '#01496e'
      break
    case '#7de3f4':
      iconBgColor = '#006184'
      break
    case '#ffb81c':
      iconBgColor = '#d45311'
      break
    case '#f68d2e':
      iconBgColor = '#a43500'
      break
    case '#fc4e6d':
      iconBgColor = '#8f124a'
      break
    default:
      break
  }
  const iconCss = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: ${iconBgColor};
    width: 60px;
    height: 60px;
  `
  const tileTitleCss = css`
    font-family: 'Noto Sans', sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: ${iconBgColor};
    text-align: start;
    text-transform: uppercase;
  `
  const tileImage = useInnerTileVisuals(icon, color)

  return (
    <div style={{ margin: '20px' }}>
      <div css={iconCss}>{tileImage.icon}</div>
      <Separator size="xs" />
      <h3 css={tileTitleCss}>{title}</h3>
      <Separator size="xs" />
      <H4 size="H5" centered={false}>
        {header}
      </H4>
      {subHeading && <H5 supplementary>{subHeading}</H5>}
      <Separator />
    </div>
  )
}

TileText.propTypes = {
  icon: string,
  color: string,
  title: string,
  header: string,
  subHeading: string,
}
